/* eslint-disable import/no-cycle */
/* eslint-disable import/prefer-default-export */
import { createSelector } from 'reselect';
import { ROOT_SLICE } from '../constants';
import { selectCustomer as baseSelectCustomer } from '../slices/Base/selectors';

import { selectIsLoadingIsLoaded as apmSelectIsLoadingIsLoaded } from '../slices/AegionProjectManagers/selectors';
import { selectIsLoadingIsLoaded as arsSelectIsLoadingIsLoaded } from '../slices/Areas/selectors';
import { selectIsLoadingIsLoaded as cmrSelectIsLoadingIsLoaded } from '../slices/Customers/selectors';
import { selectIsLoadingIsLoaded as etySelectIsLoadingIsLoaded } from '../slices/Entities/selectors';

import { selectIsLoadingIsLoaded as jbsSelectIsLoadingIsLoaded } from '../slices/Jobs/selectors';
import { selectIsLoadingIsLoaded as lnsSelectIsLoadingIsLoaded } from '../slices/Lines/selectors';
import { selectIsLoadingIsLoaded as ppsSelectIsLoadingIsLoaded } from '../slices/Pipes/selectors';
import { selectIsLoadingIsLoaded as pmsSelectIsLoadingIsLoaded } from '../slices/ProjectManagers/selectors';

import { selectIsLoadingIsLoaded as rgsSelectIsLoadingIsLoaded } from '../slices/RegulatoryStatus/selectors';
import { selectIsLoadingIsLoaded as stsSelectIsLoadingIsLoaded } from '../slices/Statuses/selectors';
import { selectIsLoadingIsLoaded as sprSelectIsLoadingIsLoaded } from '../slices/Supervisors/selectors';
import { selectIsLoadingIsLoaded as tchSelectIsLoadingIsLoaded } from '../slices/Technicians/selectors';

const EMPTY_ARRAY = [];

const consoleLogDebugger = (txt, debug) => { 
  if (debug) {
    console.log(ROOT_SLICE);
    // debugger;
  }
}

export const selectRootSliceFCCJ = (state, debug = false) => { 
  if (state[ROOT_SLICE]) { 
    consoleLogDebugger('found', debug);
    return state[ROOT_SLICE];
  }

  // else assume state is already root.
  consoleLogDebugger('not found', debug);
  return state;
};

/**
 * DUCTAPE
 * selectors that tie in from other slices, allowing to document where these values belong, in a single place.
 */

export const selectCustomer = (state) => baseSelectCustomer(state);

export const selectAvailableCustomers = state => state?.jobs?.availableCustomers || EMPTY_ARRAY;

export const selectIsLoadedResources = createSelector(
  apmSelectIsLoadingIsLoaded,
  arsSelectIsLoadingIsLoaded,
  cmrSelectIsLoadingIsLoaded,
  etySelectIsLoadingIsLoaded,
  jbsSelectIsLoadingIsLoaded,
  lnsSelectIsLoadingIsLoaded,
  ppsSelectIsLoadingIsLoaded,
  pmsSelectIsLoadingIsLoaded,
  rgsSelectIsLoadingIsLoaded,
  stsSelectIsLoadingIsLoaded,
  sprSelectIsLoadingIsLoaded,
  tchSelectIsLoadingIsLoaded,
  (...slices) => {
    return slices.every(slice => slice.isLoaded);
  }
);

export const selectIsLoadingResources = createSelector(
  apmSelectIsLoadingIsLoaded,
  arsSelectIsLoadingIsLoaded,
  cmrSelectIsLoadingIsLoaded,
  etySelectIsLoadingIsLoaded,
  jbsSelectIsLoadingIsLoaded,
  lnsSelectIsLoadingIsLoaded,
  ppsSelectIsLoadingIsLoaded,
  pmsSelectIsLoadingIsLoaded,
  rgsSelectIsLoadingIsLoaded,
  stsSelectIsLoadingIsLoaded,
  sprSelectIsLoadingIsLoaded,
  tchSelectIsLoadingIsLoaded,
  (...slices) => {
    return slices.every(slice => slice.isLoading);
  }
);

export default {
  selectRootSliceFCCJ,
  selectCustomer,
  selectAvailableCustomers,
  selectIsLoadedResources,
  selectIsLoadingResources,
}
